import { InteractionRequiredAuthError, BrowserAuthError } from "@azure/msal-browser";
import { msalInstance } from "../index";
import { FIRST_LOGIN_TIMESTAMP_KEY } from "./Constants";

export const getToken = async (scopes: any) => {
    const account = msalInstance.getActiveAccount();

    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    // Check if it's the first login and save the timestamp
    const firstLoginTimestamp = localStorage.getItem(FIRST_LOGIN_TIMESTAMP_KEY);
    if (!firstLoginTimestamp) {
        localStorage.setItem(FIRST_LOGIN_TIMESTAMP_KEY, new Date().toISOString());
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            account: account,
            scopes: scopes
        });
        return response.accessToken;
    } catch (error) {
        // Silent flow fails when third-party cookies are blocked or session expires.
        // Fall back to an interactive popup so the user can re-authenticate gracefully.
        if (
            error instanceof InteractionRequiredAuthError ||
            (error instanceof BrowserAuthError && (error as BrowserAuthError).errorCode === 'monitor_window_timeout')
        ) {
            const response = await msalInstance.acquireTokenPopup({
                account: account,
                scopes: scopes
            });
            return response.accessToken;
        }
        throw error;
    }
}